'use client';
import { FormGroup, FormControlLabel, CardContent, Typography, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import useNumberSelector from './useNumberSelector';

import { useTranslation } from 'react-i18next';

const NumbersSelectorUI = () => {
  const { t } = useTranslation();

  const { handleChange, selectedNumbers } = useNumberSelector();
  const numbersToSelect: JSX.Element[] = [];
  for (let index = 1; index <= 20; index += 1) {
    numbersToSelect.push(
      <Grid display='flex' justifyContent='center' alignItems='center' size={{ xs: 6, md: 3 }} key={index}>
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedNumbers.find((m) => m === index) === index}
              onChange={handleChange(index)}
              value={`${index}`}
              style={{
                color: 'var(--base-color)',
              }}
            />
          }
          label={`${t('number-text')} ${t('intlNumber', { val: index.toString() })}`}
        />
      </Grid>
    );
  }

  return (
    <CardContent>
      <Grid
        container
        style={{
          backgroundColor: 'rgba(0,0,0, 0.4)',
        }}
        offset={{ xs: 0, md: 2, lg: 3 }}
        size={{ xs: 12, md: 8, lg: 6 }}
      >
        <Grid
          display='flex'
          justifyContent='center'
          alignItems='center'
          offset={{ xs: 0, md: 2, lg: 3 }}
          size={{ xs: 12, md: 8, lg: 6 }}
        >
          <Typography variant='h5' align='center'>
            {t('number-selctor.select-1.label-text')}
          </Typography>
        </Grid>
        <Grid display='flex' justifyContent='center' alignItems='center'>
          <FormGroup row>{numbersToSelect}</FormGroup>
        </Grid>
      </Grid>
    </CardContent>
  );
};

export default NumbersSelectorUI;
